import { useMemo } from 'react'

import { Select } from '@components/shared/Select'

import type { ClSelectProps } from './types'

export const ClSelect = ({ filiValue, userCls, setFiliValue, handleSetPeriodValue }: ClSelectProps) => {
  const tooltip = useMemo(() => {
    const tooltipData = userCls.find((item) => item.filiCodigo === filiValue)
    return tooltipData ? `${tooltipData?.filiCodigo} - ${tooltipData?.filiNome}` : ''
  }, [userCls, filiValue])

  return (
    <Select
      hasController={false}
      name="dateCompetence"
      label="Centro de Lucro"
      placeholder="Centro de Lucro"
      searchable
      searchPlaceholder="Buscar centro de lucro..."
      value={filiValue}
      options={userCls.map((item) => ({
        label: item.filiCodigo === 'ALL' ? 'Todos' : `${item.filiCodigo} - ${item.filiNome}`,
        value: item.filiCodigo
      }))}
      onChange={({ target }) => {
        setFiliValue(target.value as string)
        handleSetPeriodValue({ filiCode: target.value as string })
      }}
      disabled={!(userCls?.length > 1)}
      tooltip={!(userCls?.length > 1) ? tooltip : ''}
    />
  )
}
